export default "__VITE_ASSET__j08QbqLM__"